import { render, staticRenderFns } from "./CompanyPermissionRecordsSetting.vue?vue&type=template&id=5a588e94"
import script from "./CompanyPermissionRecordsSetting.vue?vue&type=script&lang=js"
export * from "./CompanyPermissionRecordsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports